import React, { type FC } from 'react';

import { tvChannelsInfoBlockWidget } from '@/scenarios/channels';
import { useWidget } from '@/shared/hooks/useWidget';

import { InfoBlockPrimaryPurchaseButton } from '../InfoBlockPrimaryPurchaseButton/InfoBlockPrimaryPurchaseButton';
import { usePaywallContext } from '../../../hooks/usePaywallContext';

export const TvChannelsInfoBlock: FC = () => {
    const { offer, paymentPlace } = usePaywallContext();
    const TvChannels = useWidget(tvChannelsInfoBlockWidget);

    return (
        <TvChannels
            primaryButton={
                <InfoBlockPrimaryPurchaseButton
                    offer={offer}
                    paymentPlace={paymentPlace}
                    text=""
                    contentType="TvChannelsInfoBlock"
                    size={52}
                    alignment="default"
                />
            }
        />
    );
};
